export default function HourglassIcon({ width = 14, height = 14, ...props }: React.SVGProps<SVGSVGElement>) {
  return (
    <svg width={width} height={height} viewBox='0 0 14 14' fill='none' xmlns='http://www.w3.org/2000/svg' {...props}>
      <path
        d='M3.73955 3.43329C4.04361 5.18822 5.11221 6.39025 7.00002 7.00001C8.88783 6.39025 9.95643 5.18822 10.2605 3.43329C10.2785 3.31602 10.2709 3.19622 10.2382 3.08217C10.2054 2.96812 10.1483 2.86254 10.0708 2.7727C9.99327 2.68286 9.89719 2.61091 9.78916 2.56181C9.68114 2.51271 9.56376 2.48763 9.4451 2.48829H4.55494C4.43629 2.48763 4.3189 2.51271 4.21088 2.56181C4.10286 2.61091 4.00677 2.68286 3.92926 2.7727C3.85174 2.86254 3.79464 2.96812 3.76189 3.08217C3.72913 3.19622 3.72151 3.31602 3.73955 3.43329Z'
        stroke='currentColor'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path d='M2.48828 0.847656H11.5117' stroke='currentColor' strokeLinecap='round' strokeLinejoin='round' />
      <path
        d='M4.55491 11.5117C4.43631 11.5124 4.31898 11.4873 4.211 11.4382C4.10302 11.3892 4.00697 11.3173 3.92946 11.2275C3.85196 11.1377 3.79484 11.0322 3.76205 10.9182C3.72926 10.8042 3.72157 10.6845 3.73952 10.5673C4.04358 8.81234 5.11218 7.61031 6.99999 7C8.8878 7.61031 9.9564 8.81234 10.2605 10.5673C10.2784 10.6845 10.2707 10.8042 10.2379 10.9182C10.2051 11.0322 10.148 11.1377 10.0705 11.2275C9.99301 11.3173 9.89696 11.3892 9.78898 11.4382C9.681 11.4873 9.56367 11.5124 9.44507 11.5117H4.55491Z'
        stroke='currentColor'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path d='M2.48828 13.1523H11.5117' stroke='currentColor' strokeLinecap='round' strokeLinejoin='round' />
    </svg>
  );
}
